<style lang="scss">
  @import "admin";
</style>
<template>
  <el-container class="admin-container">
    <admin-header></admin-header>
    <el-container>
      <el-aside class="admin-aside">
        <el-menu router :default-active="defaultActive">
          <el-submenu v-if="isSYSAdmin" index="1">
            <template slot="title">
              <span>项目管理</span>
            </template>
            <el-menu-item index="/admin/projectApproval">
              项目审批
            </el-menu-item>
            <el-menu-item index="/admin/projectManagement">
              项目列表
            </el-menu-item>
            <el-menu-item index="/admin/newsManagement">
              定投管理
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="isSYSAdmin" index="/admin/userAction">
            数据管理
          </el-menu-item>
          <el-menu-item v-if="isSYSAdmin" index="/admin/templateManagement">
            模板管理
          </el-menu-item>
          <el-menu-item v-if="isSYSAdmin" index="/admin/preTemplate">
            预置模板
          </el-menu-item>
          <el-submenu v-if="isSYSAdmin || isProjectAdmin" index="2">
            <template slot="title">
              <span>字体管理</span>
            </template>
            <el-menu-item v-if="isSYSAdmin" index="/admin/sysFont">
              公共字体
            </el-menu-item>
            <el-menu-item index="/admin/projFont">
              字体管理
            </el-menu-item>
          </el-submenu>
          <el-submenu v-if="isSYSAdmin" index="3">
            <template slot="title">
              <span>公共资源</span>
            </template>
            <el-menu-item index="/admin/template">
              模板管理
            </el-menu-item>
            <el-menu-item index="/admin/material">
              素材管理
            </el-menu-item>
            <el-menu-item index="/admin/bgImgs">
              背景素材
            </el-menu-item>
            <el-menu-item index="/admin/textMaterial">
              文字素材
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="isSYSAdmin || isProjectAdmin" index="/admin/tagsManage">
            作品管理
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="admin-main" :class="$route.name">
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view/>
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
    import adminHeader from './admin-header'

    export default {
        components: {adminHeader},
        data() {
            return {
                defaultActive: this.$route.path
            }
        },
        watch: {
            '$route.name'() {
                this.defaultActive = this.$route.path
            }
        },
        computed: {
            isProjectAdmin() {
                return this.$store.getters['app/isProjectAdmin'];
            },
            isSYSAdmin() {
                return this.$store.getters['app/isSYSAdmin'];
            }
        },
        created() {
            this.$store.commit('admin/set_init_flag_projects', true);
            this.$store.commit('admin/set_init_flag_approval', true);
        }
    }
</script>